const axios = require('axios');

export default class {
  textStatus () {
    return 'Discando...';
  }

  startCall (call) {
    Bus.$emit(`startCall-${call.data.hash}`);

    axios.get(call.host, {
      params: {
        numero: call.called,
        ramal: call.caller,
        token: call.token,
      },
    })
      .then(({ data }) => {
        const params = new URLSearchParams();
        params.set('acao', 'pega_gravacao');
        params.set('token', call.token);
        params.set('id_chamada', data);
        params.set('id_cliente', call.client_id);

        const link = `https://api.sonax.net.br/a2billing_v2/admin/Public/dbdial_webapi.php?${params.toString()}`;
        let content = `<body><p><a href="${link}" rel="noopener noreferrer nofollow" target="_blank">Acessar gravação da chamada</a></p></body>`;

        const string = data.toString().slice(0, 6);

        if (string === 'RAMAL ') {
          content = data;

          Alert.error(data);
        }

        if (string === 'Conta ') {
          return;
        }

        const activity = {
          type: 'call',
          content,
          data: call,
          user: call.data.user,
          scheduled_at: null,
        };

        Bus.$emit(`saveActivity-${call.data.hash}`, call.data.hash, activity);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        Bus.$emit(`endCall-${call.data.hash}`);
      });
  }

  endCall () {
  }
}
